import { COLORS } from "components/consts";

export const FIELD_STYLES = {
    menuItem: { fontSize: '14px' },
    select: { fontSize: '14px !important' },
    label: { color: COLORS.Mainblue },
    switchLabel: { color: COLORS.Mainblue, fontSize: '12px', fontWeight: '600' }
} as const;

export const LAYOUT_STYLES = {
    gridContainer: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }
} as const;